import { render, staticRenderFns } from "./TerminologyFacet.vue?vue&type=template&id=73be280f&scoped=true"
import script from "./TerminologyFacet.vue?vue&type=script&lang=js"
export * from "./TerminologyFacet.vue?vue&type=script&lang=js"
import style0 from "./TerminologyFacet.vue?vue&type=style&index=0&id=73be280f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be280f",
  null
  
)

export default component.exports